module.exports = __webpack_public_path__ + "static/media/rubbish-bin.7f311756.svg";